/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ComparisonStatus } from './ComparisonStatus';
import {
    ComparisonStatusFromJSON,
    ComparisonStatusFromJSONTyped,
    ComparisonStatusToJSON,
    ComparisonStatusToJSONTyped,
} from './ComparisonStatus';

/**
 * Response when creating a comparison
 * @export
 * @interface CreateComparisonResponse
 */
export interface CreateComparisonResponse {
    /**
     * ID of the created comparison
     * @type {number}
     * @memberof CreateComparisonResponse
     */
    id: number;
    /**
     * 
     * @type {ComparisonStatus}
     * @memberof CreateComparisonResponse
     */
    status: ComparisonStatus;
    /**
     * Human-readable message about the operation
     * @type {string}
     * @memberof CreateComparisonResponse
     */
    message: string;
}



/**
 * Check if a given object implements the CreateComparisonResponse interface.
 */
export function instanceOfCreateComparisonResponse(value: object): value is CreateComparisonResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function CreateComparisonResponseFromJSON(json: any): CreateComparisonResponse {
    return CreateComparisonResponseFromJSONTyped(json, false);
}

export function CreateComparisonResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateComparisonResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'status': ComparisonStatusFromJSON(json['status']),
        'message': json['message'],
    };
}

export function CreateComparisonResponseToJSON(json: any): CreateComparisonResponse {
    return CreateComparisonResponseToJSONTyped(json, false);
}

export function CreateComparisonResponseToJSONTyped(value?: CreateComparisonResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'status': ComparisonStatusToJSON(value['status']),
        'message': value['message'],
    };
}

